import { useToast } from "./useToast";

export const useShowHttpError = () => {
  const { showError } = useToast();

  return (errorCode: string) =>
    showError({ message: `ERRORS.HTTP.${errorCode}` });
};
